<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 10.3999H5.4C4.6268 10.3999 4 11.0267 4 11.7999V21.5999C4 22.3731 4.6268 22.9999 5.4 22.9999H18C18.7732 22.9999 19.4 22.3731 19.4 21.5999V11.7999C19.4 11.0267 18.7732 10.3999 18 10.3999Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.7998 10.4V6.9C6.7998 5.60044 7.31605 4.35411 8.23498 3.43518C9.15391 2.51625 10.4002 2 11.6998 2C12.9994 2 14.2457 2.51625 15.1646 3.43518C16.0836 4.35411 16.5998 5.60044 16.5998 6.9V10.4"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6996 16.7C11.5063 16.7 11.3496 16.5433 11.3496 16.35C11.3496 16.1567 11.5063 16 11.6996 16"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M11.7002 16.7C11.8935 16.7 12.0502 16.5433 12.0502 16.35C12.0502 16.1567 11.8935 16 11.7002 16"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
